import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./AuthContext";
import { ensureHydrated, isDesktop } from "./nativeStorage";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const isResizeObserverLoopError = (message) =>
	message === "ResizeObserver loop limit exceeded" ||
	message === "ResizeObserver loop completed with undelivered notifications.";

const ignoredConsoleWarningPrefixes = [
	"[@git-diff-view/core] Mismatch detected between 'oldFileContent' and 'diff'",
	"[@git-diff-view/core] Mismatch detected between 'newFileContent' and 'diff'",
	"[@git-diff-view/core] Ignoring syntax highlighting for the current file as the raw length exceeds the threshold",
];

const shouldIgnoreConsoleWarning = (args) =>
	ignoredConsoleWarningPrefixes.some(
		(prefix) => typeof args[0] === "string" && args[0].startsWith(prefix),
	);

const originalConsoleWarn = console.warn.bind(console);
console.warn = (...args) => {
	if (shouldIgnoreConsoleWarning(args)) return;
	originalConsoleWarn(...args);
};

window.addEventListener(
	"error",
	(event) => {
		if (!isResizeObserverLoopError(event.message)) return;
		event.preventDefault();
		event.stopImmediatePropagation();
	},
	true,
);

window.addEventListener(
	"unhandledrejection",
	(event) => {
		const message =
			typeof event.reason === "string" ? event.reason : event.reason?.message;
		if (!isResizeObserverLoopError(message)) return;
		event.preventDefault();
		event.stopImmediatePropagation();
	},
	true,
);

const renderApp = () => {
	const root = ReactDOM.createRoot(document.getElementById("root"));
	root.render(
		<React.StrictMode>
			<BrowserRouter>
				<AuthProvider>
					<App />
				</AuthProvider>
			</BrowserRouter>
		</React.StrictMode>,
	);
};

// On desktop, hydrate settings from disk into localStorage before rendering so
// hooks that read from localStorage in their initializers see the right values.
if (isDesktop()) {
	ensureHydrated().finally(renderApp);
} else {
	renderApp();
}

serviceWorkerRegistration.register();
